import React from "react";
import { OMIGCard } from "../OMIGScreenWrapper";
import * as Dialog from "@radix-ui/react-dialog";
import { formatCurrency } from "../../../lib/utils";

const OMIGRewardsModal = ({
  open,
  onOpenChange,
  totalRewards,
  rewardType,
  currency,
  loading,
  onSelectBuyer,
}) => {
  const handleOpenChange = (nextOpen) => {
    if (onOpenChange) {
      onOpenChange(nextOpen);
    }
  };
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const d = new Date(dateString);
    return d.toLocaleDateString(undefined, {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  return (
    <Dialog.Root open={open} onOpenChange={handleOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/40" />
        <Dialog.Description />
        <Dialog.Content className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="max-w-xl w-full mx-4">
            <OMIGCard className="max-h-[80vh]">
              <div className="flex justify-between items-center mb-4">
                <Dialog.Title className="text-lg font-bold">
                  Your rewards
                </Dialog.Title>
                <Dialog.Close asChild>
                  <button
                    type="button"
                    className="text-sm text-crimsonGlory underline"
                  >
                    Close
                  </button>
                </Dialog.Close>
              </div>

              {loading ? (
                <p className="text-gray-600">Loading rewards…</p>
              ) : (
                <div className="max-h-[60vh] overflow-y-auto overscroll-y-contain pr-1">
                  {!totalRewards?.length && (
                    <p className="text-gray-600 text-center">
                      {rewardType === "Total" && "No Earned rewards."}
                      {rewardType === "Unclaimed" && "No Unclaimed rewards."}
                      {rewardType !== "Total" &&
                        rewardType !== "Unclaimed" &&
                        "No Pending rewards."}
                    </p>
                  )}

                  {totalRewards && (
                    <div className="space-y-3 mt-2">
                      {totalRewards?.map((reward, idx) => (
                        <OMIGCard
                          key={`reward-${idx}`}
                          variant="outline"
                          withHoverEffect
                          className="cursor-pointer"
                          onClick={() =>
                            onSelectBuyer && onSelectBuyer(reward?.buyerId)
                          }
                        >
                          <div className="flex gap-4 items-center">
                            {reward?.buyer?.listLogo && (
                              <div className="w-14 h-14 rounded-full border border-gray-100 shadow-sm flex items-center justify-center">
                                <img
                                  src={reward?.buyer?.listLogo}
                                  alt={reward?.buyer?.name}
                                  className="w-10 h-10 object-contain"
                                />
                              </div>
                            )}
                            <div className="flex-1 space-y-1">
                              <div className="font-semibold text-gray-900">
                                {reward?.buyer?.name}
                              </div>
                              <div className="text-sm text-gray-600">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: reward?.buyer?.shortDescription,
                                  }}
                                />
                              </div>
                              <div className="text-sm font-bold text-gray-900">
                                {reward?.description}
                              </div>
                              <div className="text-sm font-bold text-green-600">
                                {formatCurrency(reward?.amount, currency)}
                              </div>
                              <div className="text-sm font-bold text-gray-600">
                                {formatDate(reward?.dateRewarded)}
                              </div>
                            </div>
                          </div>
                        </OMIGCard>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </OMIGCard>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default OMIGRewardsModal;
